import React from 'react';
import { inject, observer } from 'mobx-react';
import { Tabs, Input, Button } from 'antd';
import EcodeOrder from '../order/EcodeOrder';
import Application from './Application';
import Development from './Development';
import util from '../../util';
const { getPermissions } = util;

const { TextArea } = Input;
const TabPane = Tabs.TabPane;
const store = [
  'devStore'
]
@inject(...store)
@observer
class Main extends React.Component {
  static defaultProps = {
    prefixCls: 'ecode-dev'
  }
  componentDidMount() {
    const { devStore: { initEcodeApply } } = this.props;
    initEcodeApply();
  }

  doSubmitAuth = () => {
    const { devStore: { applyAuthKey, authKey } } = this.props;
    applyAuthKey({ authKey });
  }

  onChange = (e) => {
    const { devStore: { setMobxState } } = this.props;
    setMobxState({ authKey: e.target.value });
  }

  onChangeDev = (e) => {
    const { devStore: { setMobxState } } = this.props;
    setMobxState({ authDevKey: e.target.value });
  }

  doSubmitDev = () => {
    const { devStore: { applyDevAuthKey, authDevKey } } = this.props;
    applyDevAuthKey({ authKey: authDevKey });
  }

  onTabChange = (devActiveKey) => {
    const { devStore: { setMobxState } } = this.props;
    setMobxState({ devActiveKey });
  }

  renderContent = () => {
    const { prefixCls, devStore: { devActiveKey }, ...ecodeProps } = this.props;
    if(devActiveKey === 'list') return <EcodeOrder {...ecodeProps} dev={true} />;
    if(devActiveKey === 'application') return <Application />;
    if(devActiveKey === 'development') return <Development />;
    return null;
  }

  render() {
    const {
      prefixCls, devStore: { devActiveKey }, 
    } = this.props;
    return (
      <div className={`${prefixCls}`}>
        <Tabs activeKey={devActiveKey} onChange={this.onTabChange}>
          <TabPane key="list" tab="我的"/>
          {
            !getPermissions() &&
              [
                <TabPane key="development" tab="开发授权"/>,
                <TabPane key="application" tab="应用授权"/>
              ]
          }
        </Tabs>
        { this.renderContent() }
      </div>
    )
  }
}

export default Main;


// WEBPACK FOOTER //
// ./src/components/dev/EcodeDev.js